export default __webpack_public_path__ + "static/media/nerivaldoafonso.d3913d1d.jpeg";